import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { add } from 'date-fns';
import { connect, useDispatch } from 'react-redux';
import { AgreementType, CreateAgreementDto, CustomerConnectionType } from '../../common/PricePrgClient';
import { ProgressButton } from '../../common/ProgressButton';
import { RootState } from '../../store';
import { toDateString } from '../../utils';
import { getCurrentUserPermissions } from '../user/redux/userSelectors';
import AgreementForm from './AgreementForm';
import { createAgreement } from './redux/agreementSlices';
import { getAppSettings } from '../settings/redux/settingsSelectors';

const mapStateToProps = (state: RootState) => ({
    userPermissions: getCurrentUserPermissions(state),
    isCreating: state.agreement.ui.isSaving,
    defaultCurrency: getAppSettings(state).defaultCurrency,
});

type OwnProps = {
    closeDialog: () => void;
};
type Props = ReturnType<typeof mapStateToProps> & OwnProps;

const CreateAgreementDialog = ({ closeDialog, userPermissions, isCreating, defaultCurrency }: Props) => {
    const defaultAgreementValues: CreateAgreementDto = {
        name: '',
        description: '',
        customerConnectionType: CustomerConnectionType.Customer,
        currency: defaultCurrency ?? '',
        validFrom: toDateString(new Date()),
        validTo: toDateString(add(new Date(), { days: 7 })),
        customerId: undefined,
        customerGroupId: undefined,
        agreementType: AgreementType.Regular,
        handleExternalPrices: false,
        permittedUserGroups: userPermissions.userGroups.map(c => c.userGroupId!)
    };

    const dispatch = useDispatch();

    const handleSubmit = (form: CreateAgreementDto) => {
        dispatch(createAgreement.request(form));
    };

    return (
        <Dialog open={true} maxWidth={'md'}>
            <DialogTitle>Create new Agreement</DialogTitle>
            <DialogContent sx={{ width: 900 }}>
                <AgreementForm defaultValues={defaultAgreementValues} submitForm={handleSubmit} />
            </DialogContent>
            <DialogActions>
                <Button onClick={closeDialog}>Cancel</Button>
                <ProgressButton color="primary" type="submit" form="agreement-form" isLoading={isCreating}>
                    Create
                </ProgressButton>
            </DialogActions>
        </Dialog>
    );
};

export default connect(mapStateToProps)(CreateAgreementDialog);
